import { observer } from "mobx-react";
import { Input } from "../../../../../../../../../components/inputs/input/input";
import FontBody2 from "../../../../../../../../../components/fonts/font-body2/font-body2";
import { ICompareValueTypeComponentProps } from "../condition-field";
import IntegerCompareValueStore from "../../../../../../../stores/compare-value/integer-compare-value-store";

const IntegerCompareValueField: React.FC<ICompareValueTypeComponentProps> = observer(({ store, condition, operatorSelector }) => {
    const compareValueStore: IntegerCompareValueStore = store as IntegerCompareValueStore;

    return (
        <>
            {operatorSelector}

            <Input disabled={!condition.isEditMode} type={'number'} min={0} value={compareValueStore.value} onChange={(v) => compareValueStore.setValue(v as number)} placeholder="0" />

            {condition.text && <FontBody2>{condition.text}</FontBody2>}
        </>
    );
});

export default IntegerCompareValueField;